export const isNumber = function(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
};

// Builds the "Any / at least X of N / All" options for a group's quantifier
// dropdown, based on how many conditions currently live in that group.
export const quantifierOptions = function (count) {
  const n = Math.max(count, 1);
  if (n === 1) {
    return [{value: 1, label: 'Any'}];
  }
  const options = [{value: 1, label: 'Any'}];
  for (let i = 2; i < n; i++) {
    options.push({value: i, label: `at least ${i} of ${n}`});
  }
  options.push({value: n, label: 'All'});
  return options;
};

// The label shown between conditions within a single group: conjunctive
// ("And") only when every condition in the group is required, otherwise
// disjunctive ("Or").
export const groupSeparator = function (group) {
  const n = Math.max((group.conditions || []).length, 1);
  return group.minTrue >= n ? 'And' : 'Or';
};

// Human-readable description of what triggers "then" vs "otherwise" for a
// scenario, based on its groups' quantifiers and how the groups themselves
// combine.
export const scenarioHelp = function (scenario) {
  const groups = scenario.groups || [];

  if (groups.length <= 1) {
    const group = groups[0];
    const conditions = group ? (group.conditions || []) : [];
    const n = Math.max(conditions.length, 1);
    const minTrue = group ? group.minTrue : 1;

    // A single, still-blank condition is the intentional "run
    // unconditionally" shorthand: "then" always fires and "otherwise"
    // never does.
    if (conditions.length <= 1 && !(conditions[0] && conditions[0].type)) {
      return {
        helpThen: 'Always - no condition has been set, so this always runs',
        helpOtherwise: 'Never - since the "then" above always runs instead'
      };
    }

    if (minTrue <= 1) {
      // "Any" (OR): the opposite of "any true" is "all false"
      return {
        helpThen: 'When any of the conditions above are true',
        helpOtherwise: 'When all of the conditions above are false'
      };
    }
    if (minTrue >= n) {
      // "All" (AND): the opposite of "all true" is "any false"
      return {
        helpThen: 'When all of the conditions above are true',
        helpOtherwise: 'When any of the conditions above are false'
      };
    }
    // "At least X of N": the opposite is "fewer than X are true"
    return {
      helpThen: `When at least ${minTrue} of the conditions above are true`,
      helpOtherwise: `When ${minTrue - 1} or fewer of the conditions above are true`
    };
  }

  if (scenario.groupOperator === 'any') {
    return {
      helpThen: 'When any of the groups above are satisfied',
      helpOtherwise: 'When none of the groups above are satisfied'
    };
  }

  return {
    helpThen: 'When all of the groups above are satisfied',
    helpOtherwise: 'When at least one of the groups above is not satisfied'
  };
};
export const isInteger = function(n) {
  return !isNaN(n) && 
   parseInt(Number(n)) == n && 
   !isNaN(parseInt(n, 10));
};

export const capitalize = function (value) {
  if (!value) {return '';}
  value = value.toString();

  // replace underscores with a space and capitalize the first letter after
  return value.replace(/(^|_)(\w)/g, function ($0, $1, $2) {
    return ($1 && ' ') + $2.toUpperCase();
  });
};

export const roundingMethods = [
  {value: 'nearest', label: 'to the nearest'},
  {value: 'up', label: 'up to the'},
  {value: 'down', label: 'down to the'}
];
export const precisionTypes = [
  {value: '.01', label: 'hundredths (e.g. 7777.77)'},
  {value: '.1', label: 'tenths (e.g. 7777.7)'},
  {value: '1', label: 'ones (e.g. 7777)'},
  {value: '10', label: 'tens (e.g. 7780)'},
  {value: '100', label: 'hundreds (e.g. 7800)'}
];
export const enumValidator = function (values) {
  return function (value) {
    return values.indexOf(value) !== -1;
  }
};

export const validateNumeric = function(component) {
  let errors = {};

  if (component.fieldsForDropdown && component.fieldsForDropdown.length > 1) {
    const found = component.fieldsForDropdown
      .filter(field => field.name == component.exportTag)
      .length > 0;
    if (!component.exportTag) {
      errors.exportTag = 'Please select a field to evaluate.'
    } else if (!found) {
      errors.exportTag = 'Invalid field selected.'
    }
  }

  if (!component.operator) {
    errors.operator = "Please select a comparison operator.";
  }

  if (component.amountortarget === "amount") {
    if (!isNumber(component.amount) && component.operatorIsNumeric) {
      errors.amount = "Must provide a numeric value for this operator.";
    }
  } else if (component.amountortarget === "variable") {
    if (!component.variable){
      errors.variable = "Must select a variable to compare against.";
    }
  } else if (component.amountortarget === "text") {
    // if it is a text operator AND is an empty string
    if (!component.operatorIsNumeric && component.operatorTakesArgs && !component.text) {
      errors.text = "Must insert a text value for this operator.";
    }
  }

  return errors;
}
